import * as React from 'react'
import { PropsWithChildren, ReactElement } from 'react'
import useViewport, { BreakPointSizeMap, Viewport } from '../../hooks/useViewport'
import { makeStyles, mergeClasses, shorthands, tokens } from '@fluentui/react-components'

type Props = {
    fullWidth?: boolean
    sidePanel?: ReactElement
}

const useStyles = makeStyles({
    container: {
        display: 'grid',
        ...shorthands.gap(tokens.spacingHorizontalXXL, tokens.spacingVerticalM),
        ...shorthands.padding(0, tokens.spacingHorizontalL),
    },
    containerSmall: {
        ...shorthands.padding(0, tokens.spacingHorizontalS),
    },
    horizontal: {
        gridTemplateColumns: `3fr 2fr`,
    },
    vertical: {
        gridTemplateColumns: `1fr`,
    },
    body: {
        display: 'grid',
        ...shorthands.gap(tokens.spacingVerticalM),
    },
    maxWidth: {
        maxWidth: `${BreakPointSizeMap.get(Viewport.XL)}px`,
    },
    sidePanel: {},
})

export default function FormContainer(props: PropsWithChildren<Props>): ReactElement {
    const { isViewport } = useViewport()
    const styles = useStyles()

    return (
        <div
            className={mergeClasses(
                styles.container,
                isViewport('>=', Viewport.XL) && props.sidePanel ? styles.horizontal : styles.vertical,
                isViewport('<', Viewport.Large) && styles.containerSmall,
            )}
        >
            <div className={mergeClasses(styles.body, !props.fullWidth && !props.sidePanel && styles.maxWidth)}>
                {props.children}
            </div>
            {props.sidePanel && <div className={styles.sidePanel}>{props.sidePanel}</div>}
        </div>
    )
}
